// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsLandlordPropertyCreateWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { CappsLandlordPropertyCreateWebApiHandler_create } from '@zg-rentals/ts-capps-client';

import type { CreatePropertyWebRequestDto, CreatePropertyWebResponseDto } from '@zg-rentals/ts-capps-client';

export interface CappsLandlordPropertyCreateWebApiHandler_create_Args {
  postData: CreatePropertyWebRequestDto;
}

export type CappsLandlordPropertyCreateWebApiHandler_create_Options = UseMutationOptions<
  CreatePropertyWebResponseDto,
  unknown,
  CappsLandlordPropertyCreateWebApiHandler_create_Args
>;

export const useCappsLandlordPropertyCreateWebApiHandler_create = ({
  httpClient,
  ...options
}: Omit<CappsLandlordPropertyCreateWebApiHandler_create_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsLandlordPropertyCreateWebApiHandler_create_Args) =>
      CappsLandlordPropertyCreateWebApiHandler_create(args.postData, httpClient),
  });
};
